









import Vue from "vue";
import Component from "vue-class-component";
import CardInfo from "@/components/CardInfo";

Vue.component("CardInfo", CardInfo);

@Component({ name: "NoLevelsView", components: { CardInfo } })
export default class NoLevelsView extends Vue {}
